import * as yup from 'yup';
import { useForm, UseFormReturn } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

type UseUpdateOwnProfileForm = () => UseFormReturn;

export const useUpdateOwnProfileForm: UseUpdateOwnProfileForm = () => {
  const schema = yup.object().shape({
    email: yup.string().email('Email is invalid'),
    name: yup.string(),
  });

  return useForm({
    resolver: yupResolver(schema),
    mode: 'onChange',
  });
};
